import {connect} from 'react-redux';
import React, {Component} from 'react';

import {showAuthModal, changeFavorites} from "../../actions/User";

const defaultProps = {
    showAuthModal: isShowAuthModal => {
    },
    changeFavorites: objectId => {
    }
};

class ChangeFavorites extends Component {
    handleChangeFavoritesClick(event) {
        event.preventDefault();

        if (this.props.currentUser.accessToken === null) {
            this.props.showAuthModal(true);
        } else {
            this.props.changeFavorites(this.props.currentObject.id);
        }
    }

    render() {
        const i18n = this.props.i18n;
        return (
            <a
                href=""
                onClick={::this.handleChangeFavoritesClick}
                className="add-bookmark">
                {this.props.currentUser.favorites.includes(this.props.currentObject.id) ?
                    i18n['objectPage.removeFromFavorites']
                    :
                    i18n['objectPage.saveToFavorites']
                }
            </a>
        )
    }
}

ChangeFavorites.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    currentUser: state.user.currentUser,
    currentObject: state.objectPage.currentObject
});

const mapDispatchToProps = {
    showAuthModal,
    changeFavorites
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeFavorites);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/ChangeFavorites.js